<template>
    <div class="play-button"></div>
</template>

<script>
export default {
    name: 'PlayButton'
}
</script>

<style scoped>
.play-button {
    width: 31px;
    height: 32px;
    border-style: solid;
    border-width: 16px 0px 16px 32px;
    box-sizing: border-box;
    border-color: transparent transparent transparent #fff;
    opacity: 0.69;
    position: absolute;
    top: 41%;
    left: 44%;
}
</style>